import type {
  AgentAddPostInput,
  AgentListPostsParams,
  AgentTogglePostStatusParams,
  RequestParams,
  AgentEditPostParams,
  AgentEditPostInput,
} from '../api'
import { api, ContentType } from '../api'

const agentAddPost = async (data: AgentAddPostInput, token: string) => {
  return await api.v1.agentAddPost({ token }, data)
}

const agentTogglePostStatus = async (data: AgentTogglePostStatusParams) => {
  return await api.v1.agentTogglePostStatus(data)
}

const agentListPosts = async (data: AgentListPostsParams) => {
  return await api.v1.agentListPosts(data)
}

const agentUploadPostPhoto = async (formData: FormData) => {
  return await api.v1.agentUploadPostPhoto({
    body: formData,
    type: ContentType.FormData,
  } as RequestParams)
}

const agentUploadPostDocument = async (formData: FormData) => {
  return await api.v1.agentUploadPostDocument({
    body: formData,
    type: ContentType.FormData,
  } as RequestParams)
}

const agentDeletePostDocument = async (postId: number, documentId: number) => {
  return await api.v1.agentDeletePostDocument({ postId, documentId })
}

const agentDeletePostPhoto = async (postId: number, photoId: number) => {
  return await api.v1.agentDeletePostPhoto({ postId, photoId })
}
const agentEditPost = async (
  { postId, token }: AgentEditPostParams,
  EditPostInput: AgentEditPostInput,
  params: RequestParams = {},
) => {
  return await api.v1.agentEditPost({ postId, token }, EditPostInput, params)
}

export default {
  agentAddPost,
  agentListPosts,
  agentTogglePostStatus,
  agentUploadPostPhoto,
  agentUploadPostDocument,
  agentDeletePostDocument,
  agentDeletePostPhoto,
  agentEditPost,
}
